import { ServiceMarketplaceDto, UserProfileDto, UserRole } from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_SERVICES_MARKETPLACE } from "../domain";

import { servicesMarketplaceApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getAllServices = async (): Promise<ServiceMarketplaceDto[]> => {
  const response = await servicesMarketplaceApi.serviceMarketplaceControllerGetServices();

  return response.data;
};

export const useGetServices = (
  user: UserProfileDto | null,
): {
  services: ServiceMarketplaceDto[] | undefined;
  servicesEnabled: boolean;
  isPendingServices: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isPending } = useQuery({
    queryKey: [DOMAIN_SERVICES_MARKETPLACE],
    queryFn: getAllServices,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return { services: data, servicesEnabled: enabled, isPendingServices: isPending };
};
